export default __webpack_public_path__ + "static/media/PlayCircle.703804dc.svg";